import WaitingForUser from "./WaitingForUser";

export default WaitingForUser;
